<template>
    <div class="popup">
        <van-popup :value="show" @click-overlay="close">
            <div class="content">
                <div class="header">
                    <div>{{ $t("Withdraw.InsertPassword") }}</div>
                    <!-- <div class="close">
                        <i class="iconfont icon-s-cuowu-guanbi" @click="close"></i>
                    </div> -->
                </div>
                <div class="info_box">
                    <div class="topTips" v-if="!isFrirstSet">{{ $t('withdrawPwd.withdrawPwdTips1') }}</div>
                    <a-form-model ref="ruleForm" :model="formData" :rules="formRules" @submit.native.prevent>
                        <a-form-model-item ref="pwd1" label="" prop="pwd1">
                            <div class="label">
                                {{ $t('withdrawPwd.withdrawPwdTips2') }}
                                <div class="eyes" @click.stop="isPwd1Dot = !isPwd1Dot">
                                    <svg v-if="isPwd1Dot" width="1em" height="1em" viewBox="0 0 16 15" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_6389_54743)">
                                            <path
                                                d="M13.4393 0.986328L11.4085 3.01709C10.3301 2.56843 9.17339 2.33836 8.00541 2.34018C6.26835 2.30606 4.56382 2.81397 3.12876 3.79333C1.6937 4.77268 0.599436 6.17479 -0.00195312 7.80478L0.0404898 7.8091L-0.00195312 7.8134C0.530735 9.33527 1.51697 10.6574 2.82392 11.6017L1.06701 13.3586L1.93592 14.2276L14.3051 1.85832L13.4393 0.986328ZM4.33654 7.77526C4.33538 7.13331 4.50343 6.50239 4.82377 5.94608C5.14411 5.38978 5.60542 4.92773 6.16121 4.6065C6.717 4.28527 7.34761 4.11619 7.98956 4.11632C8.6315 4.11646 9.2621 4.28579 9.81776 4.60725L8.69343 5.73218C8.31122 5.60091 7.89982 5.57959 7.50608 5.67065C7.11235 5.76172 6.75211 5.9615 6.46635 6.24726C6.18059 6.53302 5.98086 6.89326 5.8898 7.287C5.79874 7.68073 5.82005 8.09212 5.95132 8.47433L4.8282 9.59741C4.506 9.04419 4.33678 8.41547 4.33654 7.77526Z"
                                                fill="currentColor"></path>
                                            <path
                                                d="M7.9982 9.94133C8.57172 9.941 9.12163 9.71298 9.52712 9.30737C9.93261 8.90177 10.1605 8.35177 10.1607 7.77825C10.1607 7.76101 10.1607 7.74379 10.1607 7.72656L7.94531 9.94195C7.96316 9.93887 7.98035 9.94133 7.9982 9.94133Z"
                                                fill="currentColor"></path>
                                            <path
                                                d="M16.0005 7.80245C15.5258 6.439 14.6853 5.23233 13.5709 4.31445L11.4127 6.4726C11.6661 7.13182 11.7229 7.85037 11.5762 8.54122C11.4296 9.23207 11.0857 9.86558 10.5863 10.365C10.0869 10.8644 9.45347 11.2082 8.76262 11.3549C8.07177 11.5016 7.35318 11.4448 6.69396 11.1914L5.09766 12.7877C6.03381 13.1111 7.01735 13.2763 8.00781 13.2763C9.74304 13.31 11.4456 12.8016 12.8782 11.822C14.3109 10.8424 15.4023 9.44029 16.0005 7.81105L15.9573 7.80675L16.0005 7.80245Z"
                                                fill="currentColor"></path>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_6389_54743">
                                                <rect width="16" height="13.2394" fill="currentColor"
                                                    transform="translate(0 0.986328)">
                                                </rect>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    <svg v-else width="1em" height="1em" viewBox="0 0 16 16" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M7.9945 10.3996C6.73796 10.3996 5.70757 9.43578 5.59961 8.20815C5.606 8.08935 5.70246 7.99482 5.82255 7.99482C5.89154 7.99482 5.95351 8.02548 5.99439 8.07402C5.99567 8.07594 5.99759 8.07466 5.99759 8.06955C6.26333 8.35186 6.63959 8.52879 7.05865 8.52879C7.87057 8.52879 8.52854 7.87091 8.52854 7.05909C8.52854 6.63689 8.34968 6.26005 8.06477 5.9937C8.06541 5.99306 8.06796 5.99306 8.06668 5.99179C8.02197 5.95027 7.99386 5.89151 7.99386 5.82508C7.99386 5.70372 8.08904 5.60727 8.20914 5.59961C9.43629 5.70883 10.3996 6.73845 10.3996 7.99482C10.3996 9.32336 9.32322 10.3996 7.9945 10.3996Z"
                                            fill="currentColor"></path>
                                        <path
                                            d="M7.99966 3.19922C4.5171 3.19922 1.49678 5.14585 0 7.99365C1.49678 10.8414 4.51711 12.788 7.99966 12.788C11.4822 12.788 14.5026 10.8414 15.9993 7.99365C14.5026 5.14585 11.4822 3.19922 7.99966 3.19922ZM7.99966 11.2004C6.20002 11.2004 4.74117 9.7647 4.74117 7.99365C4.74117 6.22255 6.20004 4.7868 7.99966 4.7868C9.79926 4.7868 11.2581 6.22255 11.2581 7.99365C11.2581 9.76469 9.79926 11.2004 7.99966 11.2004Z"
                                            fill="currentColor"></path>
                                    </svg>
                                </div>
                            </div>
                            <code-input v-model="formData.pwd1" mode="box" :space="0" :maxlength="6" hairline :color="primaryColor"
                                :dot="isPwd1Dot" size="48"></code-input>
                        </a-form-model-item>
                        <a-form-model-item ref="pwd2" label="" prop="pwd2">
                            <div class="label">
                                {{ $t('withdrawPwd.withdrawPwdTips2') }}
                                <div class="eyes" @click.stop="isPwd2Dot = !isPwd2Dot">
                                    <svg v-if="isPwd2Dot" width="1em" height="1em" viewBox="0 0 16 15" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_6389_54743)">
                                            <path
                                                d="M13.4393 0.986328L11.4085 3.01709C10.3301 2.56843 9.17339 2.33836 8.00541 2.34018C6.26835 2.30606 4.56382 2.81397 3.12876 3.79333C1.6937 4.77268 0.599436 6.17479 -0.00195312 7.80478L0.0404898 7.8091L-0.00195312 7.8134C0.530735 9.33527 1.51697 10.6574 2.82392 11.6017L1.06701 13.3586L1.93592 14.2276L14.3051 1.85832L13.4393 0.986328ZM4.33654 7.77526C4.33538 7.13331 4.50343 6.50239 4.82377 5.94608C5.14411 5.38978 5.60542 4.92773 6.16121 4.6065C6.717 4.28527 7.34761 4.11619 7.98956 4.11632C8.6315 4.11646 9.2621 4.28579 9.81776 4.60725L8.69343 5.73218C8.31122 5.60091 7.89982 5.57959 7.50608 5.67065C7.11235 5.76172 6.75211 5.9615 6.46635 6.24726C6.18059 6.53302 5.98086 6.89326 5.8898 7.287C5.79874 7.68073 5.82005 8.09212 5.95132 8.47433L4.8282 9.59741C4.506 9.04419 4.33678 8.41547 4.33654 7.77526Z"
                                                fill="currentColor"></path>
                                            <path
                                                d="M7.9982 9.94133C8.57172 9.941 9.12163 9.71298 9.52712 9.30737C9.93261 8.90177 10.1605 8.35177 10.1607 7.77825C10.1607 7.76101 10.1607 7.74379 10.1607 7.72656L7.94531 9.94195C7.96316 9.93887 7.98035 9.94133 7.9982 9.94133Z"
                                                fill="currentColor"></path>
                                            <path
                                                d="M16.0005 7.80245C15.5258 6.439 14.6853 5.23233 13.5709 4.31445L11.4127 6.4726C11.6661 7.13182 11.7229 7.85037 11.5762 8.54122C11.4296 9.23207 11.0857 9.86558 10.5863 10.365C10.0869 10.8644 9.45347 11.2082 8.76262 11.3549C8.07177 11.5016 7.35318 11.4448 6.69396 11.1914L5.09766 12.7877C6.03381 13.1111 7.01735 13.2763 8.00781 13.2763C9.74304 13.31 11.4456 12.8016 12.8782 11.822C14.3109 10.8424 15.4023 9.44029 16.0005 7.81105L15.9573 7.80675L16.0005 7.80245Z"
                                                fill="currentColor"></path>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_6389_54743">
                                                <rect width="16" height="13.2394" fill="currentColor"
                                                    transform="translate(0 0.986328)">
                                                </rect>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    <svg v-else width="1em" height="1em" viewBox="0 0 16 16" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M7.9945 10.3996C6.73796 10.3996 5.70757 9.43578 5.59961 8.20815C5.606 8.08935 5.70246 7.99482 5.82255 7.99482C5.89154 7.99482 5.95351 8.02548 5.99439 8.07402C5.99567 8.07594 5.99759 8.07466 5.99759 8.06955C6.26333 8.35186 6.63959 8.52879 7.05865 8.52879C7.87057 8.52879 8.52854 7.87091 8.52854 7.05909C8.52854 6.63689 8.34968 6.26005 8.06477 5.9937C8.06541 5.99306 8.06796 5.99306 8.06668 5.99179C8.02197 5.95027 7.99386 5.89151 7.99386 5.82508C7.99386 5.70372 8.08904 5.60727 8.20914 5.59961C9.43629 5.70883 10.3996 6.73845 10.3996 7.99482C10.3996 9.32336 9.32322 10.3996 7.9945 10.3996Z"
                                            fill="currentColor"></path>
                                        <path
                                            d="M7.99966 3.19922C4.5171 3.19922 1.49678 5.14585 0 7.99365C1.49678 10.8414 4.51711 12.788 7.99966 12.788C11.4822 12.788 14.5026 10.8414 15.9993 7.99365C14.5026 5.14585 11.4822 3.19922 7.99966 3.19922ZM7.99966 11.2004C6.20002 11.2004 4.74117 9.7647 4.74117 7.99365C4.74117 6.22255 6.20004 4.7868 7.99966 4.7868C9.79926 4.7868 11.2581 6.22255 11.2581 7.99365C11.2581 9.76469 9.79926 11.2004 7.99966 11.2004Z"
                                            fill="currentColor"></path>
                                    </svg>
                                </div>
                            </div>
                            <code-input v-model="formData.pwd2" mode="box" :space="0" :maxlength="6" hairline :color="primaryColor"
                                :dot="isPwd2Dot" size="48"></code-input>
                        </a-form-model-item>
                    </a-form-model>
                    <div class="botTips">{{ $t('withdrawPwd.withdrawPwdTips3') }}</div>
                </div>
                <div class="action_btn" @click="handleSubmit">
                    <span>{{ $t("lang.confirm") }}</span>
                </div>
            </div>
            <div class="close-icon" @click="close">
                <i class="iconfont icon-s-cuowu-guanbi" ></i>
            </div>
        </van-popup>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { modifyWithdrawPassword } from '@/api/withdraw'
import { getUserInfo } from '@/api/user'
import { Toast } from 'vant'
import md5 from 'md5'
import codeInput from '@/components/codeInput'
export default {
    name: 'withdrawPwdSet',
    components: { codeInput },
    data() {
        return {
            primaryColor: 'var(--theme-bright-text)',
            formData: {
                pwd1: '',
                pwd2: ''
            },
            formRules: {
                // pwd1: [{
                //     required: true,
                //     message: this.$t('withdrawPwd.PleaseEnterWithdrawalPassword'),
                //     trigger: ['blur', 'change']
                // }, {
                //     pattern: /^(?=.*\d)(?!.*(\d)\1{5}).{6}$/,
                //     transform(value) {
                //         return String(value);
                //     },
                //     message: this.$t('withdrawPwd.notContinuousNumbers'),
                //     trigger: ['blur', 'change']
                // }],
                // pwd2: [{
                //     required: true,
                //     message: this.$t('withdrawPwd.ConfirmWithdrawalPassword'),
                //     trigger: ['blur', 'change']
                // }, {
                //     pattern: /^(?=.*\d)(?!.*(\d)\1{5}).{6}$/,
                //     transform(value) {
                //         return String(value);
                //     },
                //     message: this.$t('withdrawPwd.notContinuousNumbers'),
                //     trigger: ['blur', 'change']
                // }]
            },
            isPwd1Dot: true,
            isPwd2Dot: true,
            pageType: ''
        }
    },
    computed: {
        ...mapState({
            device: state => state.app.device
        }),
        classObj() {
            return {
                mobile: this.device === 'mobile'
            }
        },
        show: {
            get() {
                return this.$store.getters.isShowWithdrawPwdSetPopup
            },
            set(val) {
                return val
            }
        },
        isFrirstSet() {
            const uInfo = this.$store.getters.userInfo
            return uInfo && uInfo.existsWithdrawPassword
        }
    },
    methods: {
        close() {
            this.formData = {
                pwd1: '',
                pwd2: ''
            }
            this.$store.dispatch('user/setIsShowWithdrawPwdSetPopup', false)
        },
        handleSubmit() {
            const that = this
            const formdata = that.formData
            that.$refs.ruleForm.validate(valid => {
                if (valid) {
                    if (!formdata.pwd1) {
                        Toast(this.$t('withdrawPwd.PleaseEnterWithdrawalPassword'))
                        return
                    }
                    const pwdReg = /^(?=.*\d)(?!.*(\d)\1{5}).{6}$/
                    if (!pwdReg.test(formdata.pwd1)) {
                        Toast(that.$t('withdrawPwd.notContinuousNumbers'))
                        return
                    }
                    if (!formdata.pwd2) {
                        Toast(this.$t('withdrawPwd.ConfirmWithdrawalPassword'))
                        return
                    }
                    if (!pwdReg.test(formdata.pwd2)) {
                        Toast(that.$t('withdrawPwd.notContinuousNumbers'))
                        return
                    }
                    if (formdata.pwd1 !== formdata.pwd2) {
                        Toast(this.$t('withdrawPwd.InputInconsistentWithdrawPassword'))
                        return
                    }
                    const params = {
                        withdrawPassword: md5(formdata.pwd1),
                        withdrawPasswordVerify: md5(formdata.pwd2)
                    }
                    modifyWithdrawPassword(params).then((res) => {
                        if (res.code) return
                        getUserInfo().then((uInfo) => {
                            if (uInfo.code) return
                            that.$store.dispatch('user/saveUserInfo', uInfo.result)
                        })
                        that.close()
                    })
                }
            })
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/common/styles/viriables.scss';

.popup {
    --withdraw-pwd-icon-color: #{$font-color};
    --withdraw-pwd-input-color: #{$font-color};

    .van-popup {
        background: transparent;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        width: 100%;

        .content {
            box-sizing: border-box;
            border: .01rem solid transparent;
            background-image:
                linear-gradient(to right, var(--theme-popup-box-bg), var(--theme-popup-box-bg)),
                linear-gradient(90deg, var(--theme-popup-box-border), var(--theme-popup-box-border));
            background-origin: border-box;
            background-clip: content-box, border-box;
            box-shadow: var(--theme-popup-box-shadow);
            width: 94%;
            max-width: 500px;
            // height: 700px;
            border-radius: .24rem;
            overflow: hidden;
            display: flex;
            flex-direction: column;

            .header {
                display: flex;
                height: 1rem;
                padding: 0 .36rem;
                display: flex;
                align-items: center;
                justify-content: center;

                &>div:first-child {
                    font-size: .36rem;
                    font-weight: bold;
                    color: $font-color;
                    font-family: Tahoma, Tahoma;
                }

                .close {
                    color: $font-iconfont-color;
                    font-size: .42rem;
                    font-weight: bold;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    transition: all 0.3s;

                    &:hover {
                        color: $font-color;
                        rotate: -180deg;
                    }
                }
            }

            .info_box {
                padding: .28rem .24rem;
                margin: .18rem;
                margin-top: 0;
                box-shadow: inset 8px 8px 30px 0px rgba(255,255,255,0.2), inset -8px -8px 30px 0px rgba(255,255,255,0.2);
                background: var(--theme-popup-panel-bg);
                border-radius: .28rem;

                .topTips {
                    width: 100%;
                    text-align: left;
                     color: var(--theme-bright-text);font-size: .22rem;
                    line-height: 1.4;
                    padding-bottom: .1rem;
                }

                .label {
                     color: var(--theme-bright-text);font-size: .26rem;
                    position: relative;
                    line-height: 1.88;
                    text-align: left;

                    .eyes {
                        position: absolute;
                        width: .36rem;
                        height: .36rem;
                        top: calc(50% - .18rem);
                        right: 0;

                        svg {
                            width: 100%;
                            height: 100%;
                            color: var(--withdraw-pwd-icon-color);
                        }
                    }
                }

                .botTips {
                    color: var(--theme-sidebar-item-text);
                    font-size: .22rem;
                    line-height: .3rem;
                    padding-top: 0;
                    text-align: left;
                }

                .form_btn_box {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    position: fixed;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    z-index: 1;
                    bottom: 0;
                    background: $bg-box-color;
                    padding: .2rem;
                    box-shadow: 0 -.03rem .1rem 0 rgba($shadow-component-base-color, .1);
                }
            }

            .action_btn {
                height: .7rem;
                width: 60%;
                background: $bg-btn-color;
                border-radius: .64rem;
                margin: .4rem auto;
                margin-bottom: .3rem;
                font-family: eryawenrunti;
                font-size: .3rem;
                color: $font-btn-color;
                text-align: center;
                line-height: .7rem;
                cursor: pointer;

                &.disabled {
                    background: $bg-component-disabled-solid-color;
                    color: rgba($font-title-color, .45);
                    cursor: not-allowed;
                    box-shadow: 0 .06rem 0 0 $shadow-component-base-color, 0 .02rem .03rem 0 $border-component-deep-color, 0 .02rem .03rem 0 $font-component-pale-color;
                }
            }
        }
        .close-icon {
            background: var(--theme-popup-close-bg);
            border: .01rem solid var(--theme-popup-close-border);
            width: .68rem;
            height: .68rem;
            border-radius: .12rem;
            align-items: center;
            justify-content: center;
            display: flex;
            cursor: pointer;
            margin-top: .28rem;

            i {
                 color: var(--theme-bright-text);font-size: .32rem;
                vertical-align: middle;
                line-height: 1;
            }
        }
    }
}
</style>
